import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { Redirect } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { useParams } from "react-router-dom";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import { bookingApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";

const useStyles = makeStyles(styles);

const DeleteOnlineBookingHomeContent = props => {
  const classes = useStyles();

  const { id } = useParams();

  const [redirect, setRedirect] = useState(false);
  const [input, setInput] = useState({
    title: "",
    description: "",
    banner: "",
    url: ""
  });

  const deleteOnlineBookingHomeContentSignal = useRef(new AbortController());

  const getData = () => {
    bookingApi
      .get("OnlineBookingHomeContents/" + id, {
        signal: deleteOnlineBookingHomeContentSignal.current.signal
      })
      .then(data => {
        setInput({
          ...input,
          title: data.title,
          banner: data.banner,
          description: data.description,
          url: data.action
        });
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    getData();
    return () => deleteOnlineBookingHomeContentSignal.current.abort();
  }, []);

  const onPressDelete = () => {
    bookingApi
      .delete("OnlineBookingHomeContents/" + id, {
        signal: deleteOnlineBookingHomeContentSignal.current.signal
      })
      .then(() => {
        setRedirect(true);
      })
      .catch(error => console.log(error));
  };

  return redirect ? (
    <Redirect to={"/admin/OnlineBookingHomeContentList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              DELETE ONLINE BOOKING HOME CONTENT
            </h4>
          </CardHeader>
          <CardBody>
            <p>Delete this Home Content?</p>
            <Button onClick={() => props.history.goBack()} value="Back">
              CANCEL
            </Button>
            <Button
              onClick={() => onPressDelete()}
              color="rose"
              type="submit"
              value="Submit"
            >
              DELETE
            </Button>
            <form>
              <CustomInput
                labelText="Title"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.title === null ? "" : input.title,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Description"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.title === null ? "" : input.description,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Banner URL"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.banner === null ? "" : input.banner,
                  disabled: true
                }}
              />

              <CustomInput
                labelText="Web Url"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.url === null ? "" : input.url,
                  disabled: true
                }}
              />
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default DeleteOnlineBookingHomeContent;

DeleteOnlineBookingHomeContent.propTypes = {
  history: PropTypes.object
};
